<template>

  <div class="row">
    <div class="row h-40 mb-5">
      <div class="col-md-4">
        <AsyncSelect
          :api-service="fetchProductList"
          placeholder="Select Product"
          v-model="productId"
          label="text"
          :format-label="option => option.text"
          :reduce="text => text.id"
          :selectable="option => ! tableItems.some(item => item.product_id === option.id)"
        />
      </div>

      <div class="col-md-3">
        <v-select
          v-model="groupId"
          label="name"
          placeholder="Select Product Group"
          :options="productGroups"
          :reduce="item => item.id"
        />
      </div>

      <div class="col-md-2">
        <div :class="['status-dropdown', status.toLowerCase()]" class="td-inline">
          <select v-model="status" class="form-control">
            <option value="">Select Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>

      <div class="col-md-3">
        <button class="btn btn-primary me-1" @click="searchHandler">
          Go
        </button>
        <button class="btn btn-secondary" @click="openGroupOfferHandler">
          Group Offer Setup
        </button>
      </div>
    </div>
    <Loader v-if="isLoader"/>

  </div>

</template>

<script setup>
import {ref} from 'vue'
import handlePurchase from '@/services/modules/purchase'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import Loader from "@/components/atom/LoaderComponent";

const emit = defineEmits(['handleSearch', 'onOpenGroupOffer']);
const props = defineProps({
    tableItems: {
        type: Array,
        default: () => []
    },
    productGroups: {
        type: Array,
        default: () => []
    },
})
const isLoader = ref(false);
const productId = ref(null);
const groupId = ref(null);
const status = ref('');
const {fetchProductList} = handlePurchase()

const searchHandler = () => {
  emit('handleSearch', {product_id: productId.value, status: status.value, product_head_id: groupId.value})
}

const openGroupOfferHandler = () => {
  const selectedGroup = props.productGroups.find(group => group.id === groupId.value)
  emit('onOpenGroupOffer', {id: groupId.value, name: selectedGroup ? selectedGroup.name : ''})
}

</script>

<style>
.select label {
  font-size: 14px;
}

.h-40 {
  height: 40px;
  align-items: center;
}
</style>